import type { IconSvgObject } from './types';

const SpeakerIcon: IconSvgObject = [
  ["path", { d: "M5.5 2C4.39543 2 3.5 2.89543 3.5 4L3.5 20C3.5 21.1046 4.39543 22 5.5 22L18.5 22C19.6046 22 20.5 21.1046 20.5 20V4C20.5 2.89543 19.6046 2 18.5 2L5.5 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 15C15.5 16.933 13.933 18.5 12 18.5C10.067 18.5 8.5 16.933 8.5 15C8.5 13.067 10.067 11.5 12 11.5C13.933 11.5 15.5 13.067 15.5 15Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.5 7C13.5 7.82843 12.8284 8.5 12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default SpeakerIcon;
